// John Eldhose 20200622
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, CardActions, CardContent, CardMedia, IconButton, Typography } from '@material-ui/core';
import { CheckCircle, Favorite, PlayArrow } from '@material-ui/icons';
import Loading from '../../lib/Loading';
import { postAcademy } from './lib';
import { matchObjs, stream } from '../../lib/lib';
import AcademyPage from '../../../actions/AcademyPage';
import AcademyUser from '../../../actions/AcademyUser';
import RatingShow from './RatingShow';

class App extends Component {

  state = {
    loading: true
  }
  courses = [];
  handleSearch = (search) => {
    postAcademy('CourseList', { search: search }, (res) => {
      this.courses = res.data;
      this.setState({ loading: false });
    });
  }
  componentWillMount() {
    this.handleSearch(this.props.search);
  }
  componentDidUpdate(prevProps) {
    if(!matchObjs(prevProps, this.props, 'search'))
      this.handleSearch(this.props.search);
  }
  media = (details) => {
    var image = (typeof details.icon === 'undefined') ? '' : details.icon;
    if(image === '')
      image = 'academy_icon.png';
    return (
      <CardMedia
        component='img'
        image={stream('academy/images/' + image)}
        style={{ width: '240px', height: '145px' }}
      />
    );
  }
  completed = (course) => {
    if((
      course.property === 'Courses' &&
      typeof this.props.user.courses !== 'undefined' &&
      this.props.user.courses.includes(course.id)
    ) || (
      course.property === 'Learning Paths' &&
      this.props.user.learningpaths.includes(course.id)
    ))
      return (
        <CheckCircle
          style={{
            transform: 'scale(.65)', color: 'green', paddingLeft: '13px'
          }}
        />
      );
    else
      return <div />;
  }
  handlePaly = (course) => {
    this.props.AcademyPage(course.property, { id: course.id });
  }
  actions = (course) => {
    return (
      <CardActions>
        <IconButton
          color='primary'
          onClick={() => this.handlePaly(course)}
        >
          <PlayArrow />
        </IconButton>
        <IconButton
          color={this.props.user.favorites.includes(course.id) ? 'secondary' : 'primary'}
          onClick={() => this.props.AcademyUser('favorite', course.id)}
        >
         <Favorite style={{ transform: 'scale(.7)' }} />
        </IconButton>
        {this.completed(course)}
      </CardActions>
    );
  }
  horizontal = (course, id) => {
    return (
      <Card
        key={id}
        style={{ minWidth: '240px', maxWidth: '240px', margin: '7px' }}
      >
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => this.handlePaly(course)}
        >
          {this.media(course.details)}
          <CardContent style={{ textAlign: 'left' }}>
            <Typography><b>{course.title}</b></Typography>
            <RatingShow
              ratingcount={course.ratingcount}
              ratingsum={course.ratingsum}
            />
          </CardContent>
        </div>
        {this.actions(course)}
      </Card>
    );
  }
  vertical = (course, id) => {
    return (
      <Card key={id} style={{ margin: '7px' }}>
        <div style={{ display: 'inline-block', float: 'left', width: '240px' }}>
          <div
            style={{ cursor: 'pointer', textAlign: 'left' }}
            onClick={() => this.handlePaly(course)}
          >
            {this.media(course.details)}
          </div>
        </div>
        <div style={{ float: 'left', width: '10px', height: '145px' }} />
        <div style={{ textAlign: 'left', paddingTop: '10px' }}>
          <div
            style={{ cursor: 'pointer', textAlign: 'left' }}
            onClick={() => this.handlePaly(course)}
          >
          <Typography variant='subheading'>
            <b>{course.title}</b>
          </Typography>
          <Typography style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {course.description}
          </Typography>
          </div>
          {this.actions(course)}
        </div>
      </Card>
    );
  }

  render() {
    if(this.state.loading)
      return <Loading />;
    else if(this.props.orientation === 'horizontal')
      return (
        <div style={{ display: 'flex', overflowX: 'auto' }}>
          {this.courses.map(this.horizontal)}
          &nbsp;
        </div>
      );
    else if(this.props.orientation === 'vertical')
      return (
        <div style={{ minHeight: '25px' }}>
          {this.courses.map(this.vertical)}
        </div>
      );
  }
}

const mapStateToProps = (state) => {
  return ({ user: state.Academy.user.details });
}
const mapDispatchToProps = (dispatch) => ({
  AcademyPage: (page, parms) => dispatch(AcademyPage(page, parms)),
  AcademyUser: (prop, user) => dispatch(AcademyUser(prop, user))
});
const CourseList = connect(mapStateToProps, mapDispatchToProps)(App);

export default CourseList;



// WEBPACK FOOTER //
// ./src/components/home/academy/CourseList.js